/**
* @file 系统设置-轮播广告-新增/编辑广告
* */
<template>
  <div id="carouselForm">
    <el-dialog title="如何获取appid" :visible.sync="visibleAppid" width="900px" :close-on-click-modal="false" append-to-body>
      <div class="appid">
        <div>
          <div>第一步</div>
          <img src="@/assets/img/appid1.png" />
        </div>
        <div>
          <div>第二步</div>
          <img src="@/assets/img/appid2.png" />
        </div>
        <div>
          <div>第三步</div>
          <img src="@/assets/img/appid2.png" />
        </div>
      </div>
    </el-dialog>

    <h2 style="margin-bottom:40px;">{{ `${id ? '编辑' : '新增'}广告` }}</h2>

    <el-form :model="form" :rules="rules" ref="form" label-width="80px">
      <el-form-item label="封面图片" prop="coverImg" class="custom-form-center">
        <up-img :file.sync="form.coverImg" width="343" height="126"></up-img>
        <div class="example">
          <p>您可以使用我们设计的免费广告封面，也可以自行设计上传</p>
          <div class="example-img">
            <img :src="mixinQiniuImg('bus-banner1')" @click="imgClick('bus-banner1')" alt="">
            <img :src="mixinQiniuImg('bus-banner2')" @click="imgClick('bus-banner2')" alt="">
            <img :src="mixinQiniuImg('bus-banner3')" @click="imgClick('bus-banner3')" alt="">
          </div>
        </div>
      </el-form-item>
      <el-form-item label="跳转页面" prop="jumpType">
        <JumpTypeSelector
          :jumpType="form.jumpType"
          :jumpTo="form.jumpTo"
          :hasActivity="true"
          @update:jumpType="jumpChange($event, 'jumpType')"
          @update:jumpTo="jumpChange($event, 'jumpTo')"
          @show-appid-info="visibleAppid = true"
        ></JumpTypeSelector>
      </el-form-item>
      <el-form-item label="备注信息">
        <el-input v-model="form.remark" maxlength="20" style="width:315px"></el-input>
      </el-form-item>
      <el-form-item label="是否启用"> <!--状态1-启用，2-禁用-->
        <el-switch v-model="form.status" :active-value="1" :inactive-value="2"></el-switch>
      </el-form-item>
      <el-form-item style="margin-top: 50px;">
        <el-button type="primary" @click="saveClick" :loading="loading">保存</el-button>
        <!-- <el-button @click="backClick">返回</el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import JumpTypeSelector from '../components/JumpTypeSelector.vue';
export default {
  name: "carouselForm",
  components: {
    JumpTypeSelector
  },
  data() {
    return {
      // 表单
      form: {
        jumpType: null,
        jumpTo: null
      },
      // 校验规则
      rules: {
        coverImg: [{ required: true, message: '请选择上传图片' }],
        jumpType: [{ required: true, message: '请选择跳转页面' }]
      },
      // 保存按钮loading
      loading: false,
      visibleAppid: false
    }
  },
  props: {
    id: Number,
    visible: Boolean
  },
  watch: {
    id: {
      handler(val) {
        val && this.getInfo()
      },
      immediate: true
    },
    visible(val) {
      if (!val) {
        this.form = { jumpTo: null }
      }
    }
  },
  methods: {
    jumpChange(val, name) {
      this.$set(this.form, name, val)
    },
    /* 选择封面 */
    imgClick(name) {
      this.$set(this.form, 'coverImg', name)
    },

    /* 保存 */
    saveClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.jumpType == 1 && !this.form.jumpTo) {
            this.$message.info('请填写appid');
            return;
          } else if (this.form.jumpType == 2 && !this.form.jumpTo) {
            this.$message.info('请填写网页链接');
            return;
          } else if (this.form.jumpType == 5 && !this.form.jumpTo) {
            this.$message.info('请填写选择线路');
            return;
          }else if (this.form.jumpType == 3) {
            this.form.jumpTo = '旅游包车页面';
          }
          if (this.id) {
            this.putFn()
          } else {
            this.postFn()
          }
        } else {
          this.$message.warning('请检查表单数据是否输入正确！');
          return false;
        }
      });
    },

    /* 接口请求-新增 */
    async postFn() {
      this.loading = true;
      let url = '/api/v1/manage/banner';
      let params = this.$utils.deepCopyFn(this.form);
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.$message.success('保存成功！');
        this.$emit('advertisingClose')
      }
      this.loading = false
    },

    /* 接口请求-修改 */
    async putFn() {
      this.loading = true;
      let url = '/api/v1/manage/banner';
      let params = this.$utils.deepCopyFn(this.form);
      let data = await this.$axios.put(url, params);
      if (data && data.code === 1) {
        this.$message.success('保存成功！');
        this.$emit('advertisingClose')
      }
      this.loading = false
    },

    /* 接口请求-详情 */
    async getInfo() {
      let url = '/api/v1/manage/banner/' + this.id;
      let data = await this.$axios.get(url)
      if (data && data.code === 1) {
        this.form = data.data || {}
        console.log(11111111)
      }
    },

    backClick() {
      this.$emit('advertisingClose')
    }
  },
}
</script>

<style lang="less">
#carouselForm {

  .example {
    padding-top: 30px;

    p {
      color: #999;
      font-size: 14px;
      font-weight: 600;
    }

    .example-img {
      display: flex;
      flex-flow: column;
      flex-wrap: wrap;

      img {
        width: 343px;
        height: 126px;
        background-color: #999;
        flex-shrink: 0;
        margin: 0 12px 12px 0;
        cursor: pointer;
      }

      img:nth-child(3) {
        margin-right: 0;
      }

      img:nth-child(6) {
        margin-right: 0;
      }
    }
  }

  .radio-row {
    margin-bottom: 10px;
    display: flex;
    align-items: center;

    .el-radio {
      flex-shrink: 0;
      width: 120px
    }
  }

  .radio-tips {
    margin: 0 0 20px 150px;
    font-size: 10px;

    span {
      color: #66b1ff;
      cursor: pointer;
    }
  }
}

.appid {
  padding: 20px 10px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 50px;

  div {
    color: #333;
    font-weight: bold;
  }

  img {
    width: 100%;
    margin-top: 10px;
    border: 5px #f7f7f7 solid;
  }
}
</style>
